import { useState } from 'react'
import { Textarea, Checkbox } from '../../components'
import { ComponentsLayout } from './layout'

export const TextareasPage = () => {
  const [simpleValue, setSimpleValue] = useState('')
  const [richValue, setRichValue] = useState('')
  const [commentValue, setCommentValue] = useState('')
  const [articleValue, setArticleValue] = useState('<h1>Meu Artigo</h1><p>Este é um <strong>exemplo</strong> de texto formatado com <em>HTML</em>.</p>')
  const [isChecked, setIsChecked] = useState(false)

  return (
    <ComponentsLayout 
      title="Textareas & Checkboxes" 
      description="Componentes de entrada de texto longo e seleção de opções"
    >
      {/* Grid de exemplos */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        
        {/* Textarea Simples */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Textarea Simples</h3>
          <div className="space-y-4">
            <Textarea
              placeholder="Digite sua mensagem..."
              value={simpleValue}
              onChange={setSimpleValue}
              rows={3}
            />
            <Textarea
              placeholder="Textarea desabilitado"
              disabled
              rows={2}
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Entrada de texto simples e longo
          </div>
        </div>

        {/* Textarea com Label e Descrição */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Com Label</h3>
          <div className="space-y-4">
            <Textarea
              label="Comentário"
              placeholder="Deixe seu comentário..."
              description="Máximo 500 caracteres"
              value={commentValue}
              onChange={setCommentValue}
              rows={4}
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Com label e texto de ajuda
          </div>
        </div>

        {/* Textarea com Erro */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Com Validação</h3>
          <div className="space-y-4">
            <Textarea
              label="Descrição"
              placeholder="Descreva o problema..."
              error="Este campo é obrigatório"
              rows={3}
            />
            <Textarea
              label="Observações"
              placeholder="Observações adicionais..."
              description="Campo opcional"
              rows={2}
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Estados de validação
          </div>
        </div>

        {/* Rich Textarea */}
        <div className="bg-white p-6 rounded-lg shadow-sm border col-span-full">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Textarea com Toolbar (Rich Editor)</h3>
          <div className="space-y-4">
            <Textarea
              variant="rich"
              label="Conteúdo do Artigo"
              placeholder="Escreva seu artigo usando as ferramentas de formatação..."
              description="Use a toolbar acima para formatar seu texto visualmente"
              value={articleValue}
              onChange={setArticleValue}
              rows={8}
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Editor de texto rico WYSIWYG com Quill.js
          </div>
        </div>

        {/* Rich Textarea sem Toolbar */}
        <div className="bg-white p-6 rounded-lg shadow-sm border col-span-full">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Rich Textarea sem Toolbar</h3>
          <div className="space-y-4">
            <Textarea
              variant="rich"
              label="Texto Formatado"
              placeholder="Digite texto HTML..."
              value={richValue}
              onChange={setRichValue}
              toolbar={false}
              rows={4}
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Rich textarea sem toolbar para entrada direta de HTML
          </div>
        </div>

        {/* Checkboxes */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Checkboxes</h3>
          <div className="space-y-4">
            <Checkbox
              id="check1"
              label="Aceito os termos e condições"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
            <Checkbox
              id="check2"
              label="Receber notificações por email"
            />
            <Checkbox
              id="check3"
              label="Checkbox desabilitado"
              disabled
            />
            <Checkbox
              id="check4"
              label="Checkbox selecionado e desabilitado"
              checked
              disabled
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Seleção de opções booleanas
          </div>
        </div>

        {/* Tamanhos Diferentes */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Tamanhos</h3>
          <div className="space-y-4">
            <Textarea
              placeholder="Textarea pequeno (2 linhas)"
              rows={2}
            />
            <Textarea
              placeholder="Textarea médio (4 linhas)"
              rows={4}
            />
            <Textarea
              placeholder="Textarea grande (6 linhas)"
              rows={6}
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Diferentes alturas via propriedade rows
          </div>
        </div>

        {/* Estados */}
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Estados Customizados</h3>
          <div className="space-y-4">
            <Textarea
              placeholder="Estado normal"
              rows={2}
            />
            <Textarea
              placeholder="Estado de sucesso"
              className="border-green-500 focus-visible:border-green-500 focus-visible:ring-green-500/20"
              rows={2}
            />
            <Textarea
              placeholder="Estado de atenção"
              className="border-yellow-500 focus-visible:border-yellow-500 focus-visible:ring-yellow-500/20"
              rows={2}
            />
          </div>
          <div className="mt-4 text-sm text-gray-600">
            <strong>Uso:</strong> Customização via className
          </div>
        </div>

      </div>

      {/* Seção de valores */}
      <div className="mt-8 bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Valores Atuais</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <strong>Textarea Simples:</strong> 
            <div className="bg-white p-2 rounded border mt-1 max-h-20 overflow-auto">
              {simpleValue || 'Vazio'}
            </div>
          </div>
          <div>
            <strong>Comentário:</strong>
            <div className="bg-white p-2 rounded border mt-1 max-h-20 overflow-auto">
              {commentValue || 'Vazio'}
            </div>
          </div>
          <div>
            <strong>Checkbox Selecionado:</strong> {isChecked ? 'Sim' : 'Não'}
          </div>
        </div>
      </div>

      {/* Seção de código */}
      <div className="mt-12 bg-white p-6 rounded-lg shadow-sm border">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Como usar</h3>
        <div className="bg-gray-50 p-4 rounded-md">
          <pre className="text-sm text-gray-800 overflow-x-auto">
{`import { Textarea, Checkbox } from '../../components'

// Textarea Simples
<Textarea
  placeholder="Digite sua mensagem..."
  value={value}
  onChange={setValue}
  rows={4}
/>

// Textarea com Rich Editor
<Textarea
  variant="rich"
  label="Conteúdo"
  placeholder="Digite com formatação..."
  value={richValue}
  onChange={setRichValue}
  toolbar={true}
  rows={6}
/>

// Checkbox
<Checkbox
  label="Aceito os termos"
  checked={isChecked}
  onChange={(e) => setIsChecked(e.target.checked)}
/>`}
          </pre>
        </div>
      </div>
    </ComponentsLayout>
  )
}
